import Routers from "./router/routes";
// eslint-disable-next-line no-unused-vars
import i18n from "./i18n";
import ScrollToTop from "./components/scrollToTop/scrollToTop";
import { Providers } from "./service/store/Providers";
function App() {
  return (
    <Providers>
      <div className="App rtl:font-neo ltr:font-josefin ">
        <ScrollToTop />
        <Routers />
      </div>
    </Providers>
  );
}

export default App;
